import { render, staticRenderFns } from "./SensorDashboard.vue?vue&type=template&id=4723c2f4"
import script from "./SensorDashboard.vue?vue&type=script&lang=js"
export * from "./SensorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports